<template>
    <div class="this-page">
       <template>
			<el-form ref="form" label-width="120px">
				
			  <el-form-item label="收件人姓名">
			    <el-input v-model="revicerName"></el-input>
			  </el-form-item>
			  <el-form-item label="收件人电话">
				 <el-input v-model="revicerPhone"></el-input>
			  </el-form-item>
			  <el-form-item label="收件国家代码">
			  	 <el-input v-model="revicerCountry"></el-input>
			  </el-form-item>
			  <el-form-item label="收件人地址">
			  	 <el-input v-model="revicerAddress"></el-input>
			  </el-form-item>
			  <el-form-item label="收件人邮编">
			  	 <el-input v-model="revicerZip"></el-input>
			  </el-form-item>
			  <el-form-item label="备注">
			  	 <el-input v-model="remark"></el-input>
			  </el-form-item>
			  <el-form-item>
			    <el-button type="primary" @click="createOrder()">立即创建</el-button>
			    <el-button>取消</el-button>
			  </el-form-item>
			</el-form>
	   </template>
    </div>
</template>
<script>
export default {
    data () {
		return {
			revicerName:'',
			revicerPhone:'',
			revicerCountry:'',
			revicerAddress:'',
			remark:'',
			revicerZip:''
			
		}
    },
	mounted() {
		
	},
    methods: {
     handleSelect(key, keyPath) {
       console.log(key, keyPath);
     },
	 createOrder(){
		this.$fetch.post('Order/createSysExpressOrder',{
			name:this.revicerName,
			phone:this.revicerPhone,
			country:this.revicerCountry,
			address:this.revicerAddress,
			remark:this.remark,
			zip:this.revicerZip
			},true).then(res=>{
			this.$router.push('/eorder/pickup')
		}) 
	 },
	 
	 
    }
}
</script>

<style scoped>
	.this-page{
		margin:10px;
		background-color: #FFFFFF;
		padding:30px
		
	}
</style>